import React, { useState, useEffect } from 'react';
import { Input } from './ui/input';

const DateInput = ({ value, onChange, name, className, required, ...props }) => {
  // value = YYYY-MM-DD (backend format), display = DD/MM/AAAA
  const [display, setDisplay] = useState('');

  useEffect(() => {
    if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [y, m, d] = value.split('-');
      setDisplay(`${d}/${m}/${y}`);
    } else if (!value) {
      setDisplay('');
    }
  }, [value]);

  const applyMask = (raw) => {
    const digits = raw.replace(/\D/g, '').slice(0, 8);
    let masked = '';
    for (let i = 0; i < digits.length; i++) {
      if (i === 2 || i === 4) masked += '/';
      masked += digits[i];
    }
    return masked;
  };

  const handleChange = (e) => {
    const masked = applyMask(e.target.value);
    setDisplay(masked);

    // Convert DD/MM/YYYY to YYYY-MM-DD when complete
    if (masked.length === 10) {
      const [d, m, y] = masked.split('/');
      const isoDate = `${y}-${m}-${d}`;
      if (onChange) {
        onChange({ target: { name, value: isoDate } });
      }
    } else if (onChange && masked.length === 0) {
      onChange({ target: { name, value: '' } });
    }
  };

  return (
    <Input
      type="text"
      inputMode="numeric"
      placeholder="DD/MM/AAAA"
      maxLength={10}
      value={display}
      onChange={handleChange}
      name={name}
      className={className}
      required={required}
      {...props}
    />
  );
};

export default DateInput;
